export const environment = {
  remote: true,
  domain: 'dev.kaitoriya.info',
  // 移行期間中: API は新 backend (staging) に向ける。同一 origin に戻す時は '' に
  apiDomain: 'dev.active-promotion.jp',
  // 新 backend は 3 システム共有の 1 DB (旧: kaitoriya)
  database: 'active-promotion',
  // dev.kaitoriya.info は Google OAuth client の許可 origin でないため無効化 (2026-09-06 代表指示)
  googleEnabled: false,
  production: true,
};
